export const usd = (cents) =>
  `$${((cents || 0) / 100).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

export const usdc = (cents) =>
  `$${((cents || 0) / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch { return "—"; }
};

export const fmtTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch { return "—"; }
};

export const STAGE_LABELS = {
  new: "New", qualified: "Qualified", appointment_set: "Appt Set", measured: "Measured",
  estimated: "Estimated", proposal_sent: "Proposal Sent", signed: "Signed",
  in_production: "In Production", complete: "Complete", warranty: "Warranty", referral: "Referral",
};

export const JOB_STAGES = ["scheduled", "material_ordered", "in_progress", "punch_list", "complete"];
export const JOB_LABELS = {
  scheduled: "Scheduled", material_ordered: "Material Ordered", in_progress: "In Progress",
  punch_list: "Punch List", complete: "Complete",
};
